import * as React from 'react'; // TODO

var FormContext = /*#__PURE__*/React.createContext({});
export default FormContext;